class SearchService {
    constructor() {
        this.ENGLISH_STORAGE_KEY = 'muslimTreeEntities_en';
        this.ARABIC_STORAGE_KEY = 'muslimTreeEntities_ar';
        this.isInitialized = false;
        this.onProgressCallback = null;
        this.currentLanguage = 'en';
    }

    setProgressCallback(callback) {
        this.onProgressCallback = callback;
    }

    setLanguage(language) {
        if (this.currentLanguage !== language) {
            this.currentLanguage = language;
            this.isInitialized = false;
            // Clear the current language's data to force reload
            const storageKey = this.getStorageKey();
            localStorage.removeItem(storageKey);
        }
    }

    getStorageKey() {
        return this.currentLanguage === 'en' ? this.ENGLISH_STORAGE_KEY : this.ARABIC_STORAGE_KEY;
    }

    async initialize() {
        try {
            const storageKey = this.getStorageKey();
            // Check if data exists in localStorage
            const existingData = localStorage.getItem(storageKey);
            if (existingData) {
                console.log(`Using existing ${this.currentLanguage} data from localStorage`);
                this.isInitialized = true;
                return;
            }

            // If no data exists, fetch from appropriate JSON file
            const filePath = this.currentLanguage === 'en' ? '/data/entities.json' : '/data/entities-arb.json';
            const response = await fetch(filePath);
            const data = await response.json();

            // Store in localStorage with progress updates
            const totalItems = data.length;
            data.forEach((item, index) => {
                if (this.onProgressCallback) {
                    this.onProgressCallback({
                        current: item.entity,
                        progress: Math.round((index + 1) / totalItems * 100),
                        total: totalItems
                    });
                }
            });

            localStorage.setItem(storageKey, JSON.stringify(data));
            console.log(`Data initialized in localStorage for ${this.currentLanguage}`);

            this.isInitialized = true;
        } catch (error) {
            console.error('Error initializing search service:', error);
            throw error;
        }
    }

    async search(query) {
        if (!this.isInitialized) {
            await this.initialize();
        }

        if (!query.trim()) {
            return [];
        }

        try {
            const storageKey = this.getStorageKey();
            const data = JSON.parse(localStorage.getItem(storageKey) || '[]');
            const searchQuery = query.toLowerCase().trim();

            return data
                .filter(item => item.entity.toLowerCase().startsWith(searchQuery))
                .slice(0, 10); // Limit to 10 results
        } catch (error) {
            console.error('Error searching:', error);
            return [];
        }
    }

    async clearData() {
        localStorage.removeItem(this.ENGLISH_STORAGE_KEY);
        localStorage.removeItem(this.ARABIC_STORAGE_KEY);
        this.isInitialized = false;
    }
}

export const searchService = new SearchService(); 